import request from '@/utils/request'

// 조회
export function getEmergencyActionPlanProcedure(params, isProgress) {
  return request({
    url: `/api/getEmergencyActionPlanProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getEmergencyActionPlanProcedureSample(isProgress) {
  return request({
    url: `/api/getEmergencyActionPlanProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function saveEmergencyActionPlanProcedure(params, isProgress) {
  return request({
    url: `/api/saveEmergencyActionPlanProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deleteEmergencyActionPlanProcedure(params, isProgress) {
  return request({
    url: `/api/deleteEmergencyActionPlanProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getEmergencyActionPlanProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getEmergencyActionPlanProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}